export default {
      id: "icon-temps_remplacement-usage",
      viewBox: "0 0 31 30",
      url: __webpack_public_path__ + "icons.svg#icon-temps_remplacement",
      toString: function () {
        return this.url;
      }
    }